/* Mighty Crunch cart janitor.
   A "bag" is an anchor line (has _bag_size) plus one or more hidden component
   lines that share its _bag_id. The drawer never renders the components
   (cart-drawer.liquid skips them), so if only the anchor were removed the
   drawer would look empty while the cart still charged for the components.

   So: intercept the ✕ on a bag anchor and remove the WHOLE group atomically
   (anchor + every line sharing its _bag_id) in one /cart/update.js call.
   A load-time sweep stays as a safety net for any orphan left by older paths. */
(function () {
  /* ---------- 1. Intercept the bag-line remove (✕) ---------- */
  // Capture phase + stopImmediatePropagation runs BEFORE Dawn's own button
  // listener, so we fully replace the default single-line removal.

  // Re-render the open drawer + header bubble in place (no page reload), so the
  // customer can keep removing bags without the drawer closing on them.
  function rerenderDrawer(itemCount) {
    return fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var dw = document.getElementById("CartDrawer");
        if (dw && sections["cart-drawer"]) {
          var tmp = document.createElement("div");
          tmp.innerHTML = sections["cart-drawer"];
          var fresh = tmp.querySelector("#CartDrawer");
          if (fresh) dw.innerHTML = fresh.innerHTML;
        }
        var bub = document.getElementById("cart-icon-bubble");
        if (bub && sections["cart-icon-bubble"]) {
          var t2 = document.createElement("div");
          t2.innerHTML = sections["cart-icon-bubble"];
          var fb = t2.querySelector("#cart-icon-bubble") || t2;
          bub.innerHTML = fb.innerHTML;
        }
        var drawerEl = document.querySelector("cart-drawer");
        if (drawerEl) drawerEl.classList.toggle("is-empty", itemCount === 0);
      });
  }

  document.addEventListener("click", function (e) {
    var host = e.target.closest && e.target.closest("cart-remove-button");
    if (!host) return;
    var line = host.closest(".mc-bag-line");
    if (!line) return; // not a bag anchor — let Dawn handle it normally

    e.preventDefault();
    e.stopImmediatePropagation();
    var inDrawer = !!host.closest("cart-drawer");

    // data-index is 1-based into cart.items (component lines are skipped in
    // rendering but still counted by the Liquid forloop, so it stays aligned).
    var idx = parseInt(host.getAttribute("data-index"), 10);
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var anchor = items[idx - 1];
        if (!anchor) return null;
        var bagId = anchor.properties && anchor.properties["_bag_id"];
        var updates = {};
        if (bagId) {
          items.forEach(function (it) {
            if (it.properties && it.properties["_bag_id"] === bagId) updates[it.key] = 0;
          });
        } else {
          updates[anchor.key] = 0; // no id → just remove the clicked line
        }
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      })
      .then(function (updated) {
        if (!inDrawer) { window.location.reload(); return; }
        return rerenderDrawer(updated ? updated.item_count : 0);
      })
      .catch(function () { window.location.reload(); });
  }, true);

  /* ---------- 2. Load-time safety sweep for stray orphans ---------- */
  var sweeping = false;
  function sweep() {
    if (sweeping) return;
    sweeping = true;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var anchors = {}, orphans = [];
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p["_bag_size"] && p._bag_id) anchors[p._bag_id] = true;
        });
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._bag_id && !p["_bag_size"] && !anchors[p._bag_id]) orphans.push(it.key);
        });
        if (!orphans.length) { sweeping = false; return; }
        var updates = {};
        orphans.forEach(function (k) { updates[k] = 0; });
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); })
          .catch(function () { sweeping = false; });
      })
      .catch(function () { sweeping = false; });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sweep);
  } else { sweep(); }
})();
